export const style = {
  buttonX: {
    sx: {
      backgroundColor: 'action.active',
      svg: {
        fontSize: '18px',
        color: '#fff',
      },
    },
  },
  button: {
    sx: {
      '&:hover': {
        backgroundColor: 'primary.main',
      },
    },
  },
  gap: {
    sx: {
      mr: 2,
    },
  },
} as const;
